import Vue from "vue";
import App from "./App.vue";
import "@/utils/rem";
import "normalize.css";
import "@/assets/style/global.less";
import "@/assets/icon/iconfont.css";
import "@/utils/elementUI";
import router from "@/router/index.js";
import { isMobile } from "@/commom";
import "element-ui/lib/theme-chalk/index.css";

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';//这个是elemen-ui的样式

// Vue.use(ElementUI);


Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
if (isMobile()) {
  Vue.prototype.$isMobile = true;
} else {
  Vue.prototype.$isMobile = false;
}
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
